import { render, staticRenderFns } from "./Vuex.vue?vue&type=template&id=5f5fc5d0&"
import script from "./Vuex.vue?vue&type=script&lang=js&"
export * from "./Vuex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports